import React, { Component } from 'react';
import { Grid, Cell, TextField } from 'react-md';
import { Link } from 'react-router-dom';
import validate from 'validate.js';

import './Info.css';

import { state } from '../services/state';

validate.validators.validCompanyName = function(
	value,
	options,
	key,
	attributes
) {
	const regexPattern = /^[\w\d\.\-\_ ]+/;
	if (!regexPattern.test(value.trim())) {
		return 'Company Name bust be valid.';
	}
};

class Info extends Component {
	constraints = {
		clientCompanyName: {
			presence: { allowEmpty: false },
			validCompanyName: true
		},
		clientName: {
			presence: { allowEmpty: false }
		},
		clientEmail: {
			presence: { allowEmpty: false },
			email: true
		},
		clientPhone: {
			presence: { allowEmpty: false },
			format: {
				pattern: /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im,
				message: function(
					value,
					attribute,
					validatorOptions,
					attributes,
					globalOptions
				) {
					return validate.format(
						'^%{num} is not a valid phone number.',
						{
							num: value
						}
					);
				}
			}
		},
		clientJob: {
			presence: { allowEmpty: false }
		}
	};

	validation;

	constructor(props) {
		super(props);

		this.state = {
			clientCompanyName: state.clientCompanyName,
			clientName: state.clientName,
			clientEmail: state.clientEmail,
			clientPhone: state.clientPhone,
			clientJob: state.clientJob,
			clientPurchaseOrder: state.clientPurchaseOrder,
			clientAdditionalInfo: state.clientAdditionalInfo
		};
	}

	handleChange = (value, event) => {
		const propName = event.target.getAttribute('data-prop');
		const newState = {};
		newState[propName] = value;
		this.setState(newState);
		state[propName] = value;
	};

	isValid = () => {
		this.validation = validate(state, this.constraints);
		return !this.validation;
	};

	nextClick = event => {
		if (!this.isValid()) {
			event.stopPropagation();
			event.preventDefault();
			return false;
		}
	};

	render() {
		const {
			clientCompanyName,
			clientName,
			clientEmail,
			clientPhone,
			clientJob,
			clientPurchaseOrder,
			clientAdditionalInfo
		} = this.state;

		const isValid = this.isValid();

		return (
			<div className="Info">
				<Grid>
					<Cell
						size={6}
						tabletOffset={1}
						desktopOffset={3}
						className="title-wrapper"
					>
						<h2 className="sub-section-title">
							Your Information, please.
						</h2>
					</Cell>
				</Grid>
				<Grid>
					<Cell
						size={6}
						tabletOffset={1}
						desktopOffset={3}
						className="info-form-wrapper"
					>
						<Grid>
							<Cell size={6} className="left-column">
								<TextField
									id="company-name"
									label="Company Name*"
									onChange={this.handleChange}
									fullWidth={true}
									defaultValue={clientCompanyName}
									data-prop="clientCompanyName"
								/>
								<TextField
									id="your-name"
									label="Your Name*"
									fullWidth={true}
									onChange={this.handleChange}
									defaultValue={clientName}
									data-prop="clientName"
								/>
								<TextField
									id="your-email"
									label="Your Email*"
									fullWidth={true}
									onChange={this.handleChange}
									defaultValue={clientEmail}
									data-prop="clientEmail"
								/>
								<TextField
									id="phone-number"
									label="Phone Number*"
									fullWidth={true}
									type="tel"
									onChange={this.handleChange}
									defaultValue={clientPhone}
									data-prop="clientPhone"
								/>
								<TextField
									id="job"
									label="Job Name/Number*"
									fullWidth={true}
									onChange={this.handleChange}
									defaultValue={clientJob}
									data-prop="clientJob"
								/>
								<TextField
									id="purchase-order"
									label="PO #"
									fullWidth={true}
									onChange={this.handleChange}
									defaultValue={clientPurchaseOrder}
									data-prop="clientPurchaseOrder"
								/>
							</Cell>
							<Cell size={6} className="right-column">
								<TextField
									id="additional-info"
									label="Any additional information..."
									rows={18}
									onChange={this.handleChange}
									defaultValue={clientAdditionalInfo}
									data-prop="clientAdditionalInfo"
								/>
							</Cell>
						</Grid>
					</Cell>
				</Grid>
				<Grid className="next-wrapper">
					<Cell size={6} tabletOffset={1} desktopOffset={3}>
						<Link to="/" className="primary-button">
							<i className="uploader-icon uploader-icon-Previous-Arrow" />{' '}
							Previous
						</Link>
						<Link
							to="/estimate"
							onClick={this.nextClick}
							className={`primary-button ${
								isValid ? '' : 'disabled'
							}`}
						>
							Next{' '}
							<i className="uploader-icon uploader-icon-Next-Arrow" />
						</Link>
					</Cell>
				</Grid>
			</div>
		);
	}
}

export default Info;



// WEBPACK FOOTER //
// ./src/pages/Info.js